import React, { useState, useCallback } from 'react';
import { Modal } from '@components/molecules/Modal';
import { ToggleSwitch } from '@components/atoms/ToggleSwitch';

interface ExportPdfConfigModalProps {
  isOpen: boolean;
  onClose: () => void;
  onExport: (options: { includeCostAndValue: boolean }) => void;
}

export const ExportPdfConfigModal: React.FC<ExportPdfConfigModalProps> = ({
  isOpen,
  onClose,
  onExport,
}) => {
  const [includeCostAndValue, setIncludeCostAndValue] = useState(true);

  const handleExport = useCallback(() => {
    onExport({ includeCostAndValue });
    onClose();
  }, [includeCostAndValue, onExport, onClose]);

  const handleClose = useCallback(() => {
    setIncludeCostAndValue(true);
    onClose();
  }, [onClose]);

  return (
    <Modal
      isOpen={isOpen}
      onClose={handleClose}
      title="Export PDF Configuration"
      description="Configure which columns to include in the exported PDF report."
      size="small"
      handleConfirm={handleExport}
      confirmText="Export PDF"
      cancelText="Cancel"
    >
      <div className="space-y-4">
        <div className="flex items-center justify-between p-3 bg-gray-50 dark:bg-gray-700 rounded-lg">
          <div>
            <p className="text-sm font-medium text-gray-900 dark:text-white">
              Avg Cost & Value
            </p>
            <p className="text-xs text-gray-500 dark:text-gray-400">
              Include average cost and inventory value columns
            </p>
          </div>
          <ToggleSwitch
            leftLabel=""
            rightLabel=""
            checked={includeCostAndValue}
            onChange={setIncludeCostAndValue}
          />
        </div>
      </div>
    </Modal>
  );
};
